var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 5.86279V16.5334C36.1667 17.9802 36.1667 18.7036 36.4483 19.2562C36.6959 19.7422 37.0911 20.1374 37.5772 20.3851C38.1298 20.6667 38.8532 20.6667 40.3 20.6667H50.9706M41.3334 33.5832H20.6667M41.3334 43.9165H20.6667M25.8334 23.2498H20.6667M36.1667 5.1665H22.7334C18.393 5.1665 16.2228 5.1665 14.5649 6.0112C13.1067 6.75422 11.9211 7.93982 11.1781 9.39808C10.3334 11.0559 10.3334 13.2261 10.3334 17.5665V44.4332C10.3334 48.7736 10.3334 50.9438 11.1781 52.6016C11.9211 54.0599 13.1067 55.2455 14.5649 55.9885C16.2228 56.8332 18.393 56.8332 22.7334 56.8332H39.2667C43.6071 56.8332 45.7773 56.8332 47.4351 55.9885C48.8934 55.2455 50.079 54.0599 50.822 52.6016C51.6667 50.9438 51.6667 48.7736 51.6667 44.4332V20.6665L36.1667 5.1665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.e4de5a39bcf7db7cde64025e7adeddc4.svg";
export { ForwardRef as ReactComponent };